import React, { Component } from 'react'
import * as Icon from 'react-feather'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/styles'
import { withRouter } from 'react-router-dom'
import { Theme } from '../../utils/Theme'
const styles = Theme()
class NotFound extends Component {
  render() {
    const { classes, history } = this.props
    return (
      <div className="row u-mt-xlarge">
        <div className="col-md-6  u-pt-xlarge u-pb-xlarge offset-3 col-xl-6 u-mr-auto">
          <div className={`c-card`}>
            <span className="c-icon c-icon--large u-mb-small">
              <Icon.AlertTriangle className={classes.colorWarning} />
            </span>
            <h5 className={`u-mb-xsmall ${classes.colorSecondary}`}>Page Not Found</h5>
            <p className={`u-mb-medium  ${classes.colorSecondary}`}>
              Sorry, but we couldn’t find the page you are looking for.
            </p>
            <button
              onClick={() => {
                history.goBack()
              }}
              className={`c-btn ${classes.buttonSecondary} u-text-center`}
            >
              {' '}
              Back
            </button>
          </div>
        </div>
      </div>
    )
  }
}

NotFound.propTypes = {
  classes: PropTypes.object,
  history: PropTypes.object,
}
const mapStateToProps = state => ({})
export default connect(mapStateToProps, {})(withStyles(styles)(withRouter(NotFound)))
